import React from 'react';

export default function getTemplate(children, template, props = {}) {
  if (!Array.isArray(children)) {
    if (children.type === template) {
      return children;
    }
  } else {
    let component;
    children.forEach((child, idx) => {
      if (!component && child.type === template) {
        component = child;
      }
    });
    if (component) {
      return React.cloneElement(component, props);
    } else {
      return null;
    }
  }
  return null;
}
